<!--
 * @Author: yuhaiqin@wps.cn
 * @Description: 入口迁移弹窗
-->
<template>
  <UIDialog v-model="visible" :width="758" title="功能迁移提醒">
    <div class="tips">
      功能即将迁移至首页【应用】，下次可以在 "应用市场" 中点击【创建应用】，创建和查看自己的应用哦~
    </div>
    <img src="@/assets/png/white/entry-migrate-01.png" />
    <img src="@/assets/png/white/entry-migrate-02.png" />
    <template #footer>
      <base-button type="primary" @click="goToWorkbench"> 立即前往 </base-button>
      <base-button @click="onGotIt">知道了</base-button>
    </template>
  </UIDialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import UIDialog from '@vas2t-lowcode/libs/src/components/ui-dialog';
import { goToWorkbench } from '@/utils/go-to-workbench';
const visible = ref(true);

const emit = defineEmits(['gotIt']);
const onGotIt = () => {
  emit('gotIt');
};
</script>

<style lang="scss" scoped>
.tips {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: var(--lowcode-text-03);
  line-height: 22px;
  margin: 8px 0 20px;
}
.footer > button {
  width: 80px;
  height: 30px;
}
img {
  width: 346px;
  height: 240px;
  margin-right: 9px;
  &:last-child {
    margin: 0 0 0 7px;
  }
}
</style>
